import { css } from '@emotion/css';
import { colors } from '@ajaibid/components';

export const styBPContainer = css`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 12px;
  margin: 16px;
  margin-top: 24px;
  border: 1px solid ${colors.NEUTRAL_2};
`;

export const styBPTitleContainer = css`
  display: flex;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  align-content: center;
  align-items: center;
`;

export const styBPTitleText = css`
  font-size: 16px;
  font-style: normal;
  font-weight: 800;
  line-height: 22px; /* 137.5% */
`;

export const styIconInfo = css`
  cursor: pointer;
  padding-top: 4px;
`;

export const styBPCard = css`
  display: flex;
  padding: 12px;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  border-radius: 12px;
  background-color: ${colors.NEUTRAL_1};
  justify-content: space-between;
`;

export const styLabelIcon = css`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`;
